import { isExpiringSoon, isFreeEvolution, isPaidEvolution } from "./picker";
/** The states the overview lists, Available first, in every surface's order. */
export const OVERVIEW_STATES = [
    "available",
    "unachieved",
    "planned",
    "inProgress",
    "completed",
];
/** Every state first, the default; then one tab per state. */
export const OVERVIEW_STATE_TABS = [
    "all",
    ...OVERVIEW_STATES,
];
export const matchesOverviewOther = (evo, key, now) => {
    switch (key) {
        case "new":
            return evo.newEvolution;
        case "free":
            return isFreeEvolution(evo);
        case "paid":
            return isPaidEvolution(evo);
        case "expiring":
            return isExpiringSoon(evo, now);
    }
};
/** Every filter must match; a name search is one more of them. */
export const filterOverviewEvolutions = (evolutions, { states, categoryIds, other, searchTerm }, now) => {
    const search = searchTerm.trim().toLowerCase();
    return evolutions.filter((evo) => (!search || evo.name.toLowerCase().includes(search)) &&
        (states.length === 0 || states.includes(evo.state)) &&
        (categoryIds.length === 0 || categoryIds.includes(evo.categoryId)) &&
        other.every((key) => matchesOverviewOther(evo, key, now)));
};
/** How many evolutions each tab holds. */
export const overviewStateCounts = (evolutions) => {
    const counts = {
        all: evolutions.length,
        available: 0,
        unachieved: 0,
        planned: 0,
        inProgress: 0,
        completed: 0,
        unknown: 0,
    };
    for (const evo of evolutions)
        counts[evo.state] += 1;
    return counts;
};
export const evolutionsOverviewSortItems = [
    { value: "new", label: "New" },
    { value: "expiry", label: "Expiry" },
    { value: "price", label: "Price" },
    { value: "matches-asc", label: "Matches" },
    { value: "biggest-upgrade", label: "Biggest Upgrade" },
];
const metaRatingGain = (evo) => {
    const top = evo.topPlayers[0];
    if (!top)
        return -Infinity;
    return top.evolutionPlayer.metaRating - top.basePlayer.metaRating;
};
/**
 * "new" is the backend's order (release date under the hood) — the array
 * is returned untouched, and every other sort works on a copy so the stored
 * order is never lost.
 */
export const sortEvolutionsForOverview = (evolutions, sort) => {
    if (sort === "new")
        return evolutions;
    const sorted = [...evolutions];
    switch (sort) {
        case "expiry":
            // Soonest unlock deadline first; evos without a deadline last.
            sorted.sort((a, b) => (a.unlockBy || Infinity) - (b.unlockBy || Infinity));
            break;
        case "price":
            sorted.sort((a, b) => (a.cost?.coins ?? 0) - (b.cost?.coins ?? 0) ||
                (a.cost?.points ?? 0) - (b.cost?.points ?? 0));
            break;
        case "matches-asc":
            sorted.sort((a, b) => (a.matches ?? 0) - (b.matches ?? 0));
            break;
        case "biggest-upgrade":
            sorted.sort((a, b) => metaRatingGain(b) - metaRatingGain(a));
            break;
    }
    return sorted;
};
//# sourceMappingURL=overview.js.map